import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { IHttpResponse } from 'src/app/core/models/IHttpResponse.interface'
import { IMenu } from '../models/IMenu.interface'

import { IUsuarioMenuDetallado } from '../models/usuario/IUsuarioMenuDetallado.interface'

@Injectable({ providedIn: 'root' })
export class UsuarioMenuService {
  private readonly http = inject(HttpClient)
  private readonly baseUrl = inject<string>('BASE_URL' as any)

  public ObtenerDisponibles(cuentaId: number, usuarioId: number) {
    return this.http.get<IHttpResponse<IUsuarioMenuDetallado[]>>(
      `${this.baseUrl}/api/v1/Sistema/Cuentas/${cuentaId}/Usuarios/${usuarioId}/Menus/Disponibles`,
    )
  }

  public Guardar(cuentaId: number, usuarioId: number, menuId: number, activo: boolean) {
    return this.http.put<IHttpResponse<number>>(
      `${this.baseUrl}/api/v1/Sistema/Cuentas/${cuentaId}/Usuarios/${usuarioId}/Menus/${menuId}`,
      { activo },
    )
  }

  public ObtenerMenuPorUsuario(usuarioId: number): Observable<IHttpResponse<IMenu[]>> {
    return this.http.get<IHttpResponse<IMenu[]>>(`${this.baseUrl}/api/v1/Sistema/Usuarios/${usuarioId}/Menus`)
  }
}
